module.exports = __webpack_public_path__ + "img/pointer.7fc5ab19.png";